const routes = {
  about: {
    p1Pre: "Reality Twin is the AI Twin platform we're building at ",
    p1Link: "Ruznic Marketing",
    p1Post:
      ", a small marketing studio based in Hinwil, Switzerland. The idea is simple: every company should have a live, conversational digital twin — trained on its own truth — that can talk to customers, qualify leads and surface opportunities at any hour of the day.",
    p2Pre: "We're ",
    p2Strong: "available now",
    p2Post:
      ". No inflated claims, no fake customer logos, no offices on three continents. Just a focused team and a product we improve with the companies actually using it.",
    p3: "If you want an AI Twin for your company — SMBs, agencies, and growing teams welcome — get in touch. We help you launch the parts of the product you actually need.",
    quote:
      "At the agency we kept watching brilliant founders answer the same five questions on calls, in emails, in pitch decks, week after week. Reality Twin is the tool I wanted to give them — an honest digital version of their company that can just be present, even when they aren't.",
    quoteRole: "Founder · Ruznic Marketing",
    principlesEyebrow: "Principles",
    principlesTitleA: "Four ideas that ",
    principlesTitleEm: "guide the product.",
    principles: [
      {
        n: "01",
        title: "Cited or it didn't happen",
        desc: "Every answer the twin gives is grounded in your knowledge. Hallucinations are bugs, not features.",
      },
      {
        n: "02",
        title: "Honest while we build",
        desc: "We're in. We don't fake logos, customers or revenue. What you see is what we've built so far.",
      },
      {
        n: "03",
        title: "Calm software",
        desc: "Reality Twin works quietly in the background and brings you outcomes — qualified questions, leads, ideas — not notifications.",
      },
      {
        n: "04",
        title: "Private by default",
        desc: "Your knowledge is yours. We keep data minimal, encrypted and — where it matters — in Switzerland.",
      },
    ],
    imprint: {
      label: "Imprint",
      operator: "Operator",
      operatorName: "Ruznic Marketing",
      ownerLine: "Owner: Ajdin Ruznic",
      address: "Address",
      addressLines: "Leimgrubstrasse 5\n8340 Hinwil\nSwitzerland",
      status: "Status",
      statusValue: "available · 2026",
      contact: "Contact",
      contactCta: "Get in touch",
    },
  },
  careers: {
    p1Pre: "Reality Twin is built by ",
    p1Link: "Ruznic Marketing",
    p1Post:
      " in Hinwil. Right now the team is intentionally tiny. We're focused on shipping the product to customers and we'd rather wait six months for the right second engineer than grow for the sake of it.",
    p2: "If you're an exceptional engineer, designer or operator and the project resonates — get in touch anyway. We'd love to keep a real conversation going so that when we're ready to grow, you're top of mind.",
    p3Pre: "Write to ",
    p3Post: " with a short note about yourself and what you'd want to build.",
    valuesEyebrow: "How we work",
    valuesTitleA: "Three things ",
    valuesTitleEm: "we believe.",
    values: [
      {
        title: "Taste matters",
        desc: "Every pixel, every word, every endpoint. We optimize for the feeling of using the product.",
      },
      {
        title: "Small team, real leverage",
        desc: "We stay small on purpose. Each person owns end-to-end and ships.",
      },
      {
        title: "Honest with ourselves",
        desc: "We don't ship vanity features and we don't fake traction. We tell the truth — to customers and to each other.",
      },
    ],
  },
  changelog: {
    entries: [
      {
        date: "June 13, 2026",
        version: "v0.1",
        title: "Reality Twin is available",
        highlights: ["New"],
        body: "Reality Twin is live. Ruznic Marketing is onboarding customers from Hinwil with rapid iteration and complete honesty about what works and what doesn't.",
      },
      {
        date: "May 2026",
        version: "Foundations",
        title: "Ingestion, knowledge graph, conversation engine",
        highlights: ["Engineering"],
        body: "The core ingestion pipeline, the citable knowledge graph and the conversational layer that powers a twin's answers — built and tested before customer rollout.",
      },
      {
        date: "Coming soon",
        version: "Roadmap",
        title: "What we're working on next",
        highlights: ["Soon"],
        body: "Personality tuning, public Twin profiles and Twin-to-Twin discovery have shipped since. Next: automatic commercial-register verification, native CRM integrations and a shared deal room. Every capability carries a live/beta/planned status on our public roadmap.",
      },
    ],
  },
  contact: {
    channelsLabel: "By channel",
    channels: [
      { title: "Get started", desc: "Create an account and launch your AI Twin." },
      { title: "Partnerships", desc: "Agencies, integrators and resellers." },
      { title: "Press", desc: "Media inquiries about Reality Twin." },
      { title: "Security", desc: "Responsible disclosure & data questions." },
    ],
    officesLabel: "Offices",
    offices: [
      {
        city: "Hinwil, Switzerland",
        address: "Ruznic Marketing\nLeimgrubstrasse 5\n8340 Hinwil, Switzerland",
      },
    ],
    formEyebrow: "Talk to sales",
    formTitle: "Tell us about your team.",
    fieldName: "Name",
    fieldEmail: "Work email",
    fieldCompany: "Company",
    fieldTeam: "Team size",
    fieldMessage: "What are you trying to do?",
    placeholders: {
      name: "Your name",
      email: "you@company.com",
      company: "Company name",
      message: "A sentence or two is plenty.",
    },
    teamOptions: ["1–10", "11–50", "51–200", "200+"],
    sendCta: "Send message",
    legalPre: "By submitting, you agree to our ",
    legalLink: "privacy policy",
    legalPost: ".",
  },
  customers: {
    p1: "Reality Twin is built for the people who actually deal with customers every day — founders answering DMs at midnight, support teams drowning in repetitive tickets, sales reps qualifying leads they'll never close. Your AI Twin handles the first conversation so your team can focus on the ones that matter.",
    p2Pre:
      "Whether you run a one-person studio or a 200-person company, Reality Twin gives every visitor a ",
    p2Strong: "real conversation with your business",
    p2Post:
      " — answering their questions with your own knowledge, capturing the right leads, and routing serious ones to the right person on your team.",
    perks: [
      {
        title: "Inbound sales",
        desc: "Every visitor gets a tailored conversation. Hot leads land in your inbox already qualified, scored and routed.",
      },
      {
        title: "Customer support",
        desc: "Your twin answers product, pricing and policy questions instantly — grounded in your docs, never invented.",
      },
      {
        title: "Marketing & content",
        desc: "Visitors stop bouncing. They explore your offering through conversation and self-discover what's relevant to them.",
      },
      {
        title: "Operations",
        desc: "Your twin handles repetitive intake — meeting requests, qualification, FAQ triage — so your team focuses on real work.",
      },
    ],
    cta: "Start with Reality Twin",
    ctaNote:
      "Get started is free. Founder-led onboarding from Hinwil — usually within one to two business days.",
  },
  docs: {
    integrateTitle: "Integrate in minutes",
    integrateWidgetTitle: "Chat widget",
    integrateWidgetDesc:
      "One script tag adds your twin as a floating chat bubble to any website. Your twin ID is shown in Settings → Integrations.",
    integrateMcpTitle: "MCP server",
    integrateMcpDesc:
      "AI assistants like Claude connect to the Reality Twin network over the Model Context Protocol — they can search the marketplace, ask any public twin a question and submit leads to your company.",
    intro1:
      "The Reality Twin developer documentation covers the basics — connecting your website, indexing knowledge, tuning your twin's personality, and embedding the chat widget — and grows every week from real customer questions.",
    intro2:
      "Official SDKs (TypeScript first, Python next), a REST API and webhooks for lead sync are on the near-term roadmap. We'd rather ship a small, accurate documentation surface than a sprawling one that lies.",
    sections: [
      {
        title: "Getting started",
        desc: "Create your first twin in 60 seconds — from website crawl to live conversation.",
        topics: ["Quickstart", "Connect your website", "First conversation", "Embed the widget"],
      },
      {
        title: "Concepts",
        desc: "How the knowledge engine, twin personality and conversation memory work together.",
        topics: ["Knowledge graph", "Twin personality", "Memory & context", "Citations"],
      },
      {
        title: "Twin-to-Twin protocol",
        desc: "Let your twin meet other twins and broker introductions automatically.",
        topics: ["Protocol overview", "Intent signals", "Trust & consent", "Matching"],
      },
      {
        title: "REST API",
        desc: "Programmatic access to conversations, leads, knowledge and the marketplace.",
        topics: ["Authentication", "Conversations", "Leads", "Webhooks"],
      },
      {
        title: "SDKs",
        desc: "Official libraries for TypeScript, Python and Go. Edge-runtime friendly.",
        topics: ["TypeScript", "Python", "Go", "Edge runtime"],
      },
      {
        title: "Security",
        desc: "How we protect your data — encryption, isolation, Swiss/EU hosting.",
        topics: ["Encryption", "Per-workspace isolation", "Data residency", "DPA"],
      },
    ],
    lookingTitle: "Looking for something specific?",
    lookingPre: "Email ",
    lookingPost: " — we reply personally.",
  },
  network: {
    p1: "The Network is live. Every company with a published Twin maintains a searchable profile — what it does, what it's looking for, what it can offer — and the Twin-to-Twin protocol makes the introductions in the background. The marketplace is free to list and indexable by search engines and AI assistants; only its size is still growing as more Twins come online.",
    p2: "Instead of pitch decks, cold emails and stale company pages, discovery happens automatically: a nightly job at 03:00 UTC runs embedding search across all listings via match_listings, an LLM scores each candidate for intent, capability and fit with a written rationale, and the strongest new matches land in your inbox the next morning.",
    soonA: "Join the network",
    soonEm: "today.",
    soonSub:
      "Publish your company profile and your Twin starts appearing in matches on the next nightly run.",
    soonCta: "Get started",
    twinEyebrow: "Twin-to-Twin",
    twinTitleA: "The network ",
    twinTitleEm: "that discovers itself.",
    twinSub:
      "When two Twins align on intent, capability and fit, Reality Twin proposes the meeting on both sides — no cold outreach. Matching runs nightly and the reasoning behind every match is visible in your dashboard.",
  },
  pricing: {
    st_beta: "beta",
    st_planned: "planned",
    tiers: [
      {
        name: "Free",
        price: "CHF 0",
        desc: "Explore the network",
        feats: [
          "50 conversations / mo",
          "1 AI Twin",
          "Public marketplace listing",
          "Community support",
        ],
        cta: "Start free",
      },
      {
        name: "Starter",
        price: "CHF 39",
        desc: "For founders shipping fast",
        feats: [
          "1,000 conversations / mo (shared)",
          "Up to 3 Twins",
          "Lead capture & scoring",
          "Buy extra conversations",
          "Email support",
        ],
        cta: "Subscribe",
      },
      {
        name: "Pro",
        price: "CHF 149",
        desc: "Growing teams",
        feats: [
          "5,000 conversations / mo (shared)",
          "Unlimited Twins",
          "Twin-to-Twin protocol",
          "Opportunity engine",
          "Priority support",
        ],
        cta: "Subscribe",
      },
      {
        name: "Scale",
        price: "CHF 399",
        desc: "High volume & scale",
        feats: [
          "20,000 conversations / mo (shared)",
          "Everything in Pro",
          "Buy extra conversations",
          "Priority support",
        ],
        cta: "Subscribe",
      },
    ],
    popular: "Popular",
    perMo: "/mo",
    compareEyebrow: "Compare plans",
    compareTitleA: "Every feature, ",
    compareTitleEm: "side by side.",
    featureHeader: "Feature",
    rows: [
      {
        label: "AI Twins",
        values: ["1", "3", "Unlimited", "Unlimited"],
      },
      {
        label: "Conversations / month (shared pool)",
        values: ["50", "1,000", "5,000", "20,000"],
      },
      {
        label: "Knowledge sources",
        values: ["Website", "Website + 10 docs", "Unlimited", "Unlimited"],
      },
      {
        label: "Lead capture & scoring",
        values: [false, true, true, true],
      },
      {
        label: "Twin-to-Twin protocol",
        values: [false, false, true, true],
      },
      {
        label: "Opportunity engine",
        values: [false, false, true, true],
      },
      {
        label: "Marketplace presence",
        values: [true, true, true, true],
      },
      {
        label: "CRM sync (Salesforce, HubSpot)",
        values: [false, true, true, true],
      },
      {
        label: "Buy extra conversations",
        values: [false, true, true, true],
      },
      {
        label: "Support",
        values: ["Community", "Email", "Priority", "Priority"],
      },
    ],
    qEyebrow: "Questions?",
    qTitle: "Need a custom plan?",
    qSub: "Custom volume, security review, regulated industries, a Swiss contracting party — we'll architect a plan for it.",
    qCta: "Talk to sales",
  },
  security: {
    pillars: [
      {
        title: "Encryption",
        desc: "TLS 1.3 in transit, AES-256 at rest. Standard, well-understood primitives — no homegrown crypto.",
      },
      {
        title: "Access control",
        desc: "Every operator account is protected by MFA. Production access is limited to the founder and reviewed regularly.",
      },
      {
        title: "Per-workspace isolation",
        desc: "Each workspace's data is partitioned at the database row level and enforced by Row-Level Security policies.",
      },
      {
        title: "EU application, global AI gateway",
        desc: "Database and application workloads run in the European Union (Supabase, Ireland). AI inference is routed through the Lovable AI Gateway, which may forward requests to model providers outside the EU (e.g. US). We disclose this openly rather than claiming full data residency.",
      },
      {
        title: "Operational integrity",
        desc: "Audit logs, error monitoring, and a small, focused stack we actually understand end-to-end.",
      },
      {
        title: "Compliance posture",
        desc: "GDPR and Swiss FADP-aligned. SOC 2 and ISO 27001 are on the roadmap — we'll say so honestly when we get there.",
      },
    ],
    progEyebrow: "Program",
    progTitleA: "Our security ",
    progTitleEm: "commitments.",
    sections: [
      {
        h2: "Application security",
        body: "All code is reviewed before merge. We use static analysis and dependency scanning on every commit. Production deploys go through automated checks.",
      },
      {
        h2: "Infrastructure & data residency",
        body: 'Application code and the primary database run on managed EU infrastructure (Supabase, Ireland; Cloudflare edge) with daily backups. Reality Twin is a Swiss company and the service is governed by Swiss law; the data itself is stored in the EU. AI inference is routed through the Lovable AI Gateway (ai.gateway.lovable.dev), which may forward prompts to model providers hosted outside the EU, including the United States. Cross-border transfers rely on Standard Contractual Clauses; see the <a href="/subprocessors">sub-processors page</a> for the full list.',
      },
      {
        h2: "Data isolation",
        body: "Every workspace's data is partitioned at the database row level and enforced by Row-Level Security policies. We don't share data across workspaces and we don't train shared models on your content.",
      },
      {
        h2: "Incident response",
        body: "If something breaks or leaks, we notify affected customers directly and quickly. As a small team we don't run a 24/7 SOC — we're honest about that, and we make up for it with rapid response from the founder.",
      },
      {
        h2: "Responsible disclosure",
        body: 'Found a vulnerability? Email <a href="mailto:hello@realitytwin.io">hello@realitytwin.io</a>. We respond within one business day and credit researchers publicly with their consent.',
      },
      {
        h2: "What we're working toward",
        body: "SOC 2 Type I, then Type II, and ISO 27001 — once the customer base and budget make sense. We'll update this page the moment we actually achieve them, not before.",
      },
    ],
  },
  privacy: {
    sections: [
      {
        h2: "1. Introduction",
        body: 'Reality Twin is a service operated by Ruznic Marketing, owned by Ajdin Ruznic, Leimgrubstrasse 5, 8340 Hinwil, Switzerland ("we", "us"). This Privacy Policy explains what information we collect, how we use it, and the rights you have over it.',
      },
      {
        h2: "2. Information we collect",
        body: "<strong>Account information:</strong> name, email, company and authentication identifiers (e.g. Google OAuth subject ID). <br/><strong>Knowledge content:</strong> the website content, documents and metadata you submit. Encrypted at rest and accessible only to your workspace. <br/><strong>Conversation data:</strong> visitor transcripts, derived lead signals and any contact info the visitor voluntarily provides. You control retention. <br/><strong>Usage telemetry:</strong> events, latency, error rates. Never sold or shared with third parties for advertising.",
      },
      {
        h2: "3. How we use information",
        body: "To operate, secure and improve the platform · To answer customer questions through your twin · To detect abuse and prevent fraud · To send service-related notifications · To meet legal and contractual obligations.",
      },
      {
        h2: "4. Sharing",
        body: 'We share data with sub-processors that operate parts of the platform — hosting, payments, analytics and email delivery. A current list is available on the <a href="/dpa">DPA page</a>. We do not sell personal data.',
      },
      {
        h2: "5. Data retention",
        body: "Account data is retained for as long as your account is active. Conversation data follows the retention you configure (default: 24 months). Backups are purged within 90 days.",
      },
      {
        h2: "6. Your rights",
        body: 'Under Swiss FADP and EU GDPR you may have the right to access, correct, export or delete your personal data. To exercise these rights email <a href="mailto:hello@realitytwin.io">hello@realitytwin.io</a>.',
      },
      {
        h2: "7. International transfers",
        body: "Application data is stored in one region: the European Union (Ireland). Reality Twin is a Swiss company and the service is governed by Swiss law, so the operator is Swiss while the storage is EU — both the GDPR and the Swiss FADP apply. AI inference may be routed to model providers outside the EU; those cross-border transfers rely on Standard Contractual Clauses.",
      },
      {
        h2: "8. Security",
        body: 'See our <a href="/security">Security page</a> for the current state of our controls.',
      },
      {
        h2: "9. Changes",
        body: "We will post material changes to this Policy on this page and notify account owners by email at least 30 days before the changes take effect.",
      },
      {
        h2: "10. Contact",
        body: 'Questions? Email <a href="mailto:hello@realitytwin.io">hello@realitytwin.io</a> or write to Ruznic Marketing, Leimgrubstrasse 5, 8340 Hinwil, Switzerland.',
      },
    ],
  },
  terms: {
    sections: [
      {
        h2: "1. Acceptance",
        body: 'By creating an account or using the Reality Twin platform ("Service") you agree to these Terms of Service ("Terms"). The Service is operated by Ruznic Marketing, owned by Ajdin Ruznic, Leimgrubstrasse 5, 8340 Hinwil, Switzerland ("we", "us"). If you are using the Service on behalf of an organization, you represent that you have authority to bind that organization.',
      },
      {
        h2: "2. The Service",
        body: "Reality Twin is a hosted AI platform that lets organizations build, deploy and operate AI Twins. Features may evolve as we improve the product with customers.",
      },
      {
        h2: "3. Your account",
        body: 'You are responsible for safeguarding your account credentials and for all activity that occurs under your account. Notify us immediately at <a href="mailto:hello@realitytwin.io">hello@realitytwin.io</a> of any unauthorized access.',
      },
      {
        h2: "4. Your content",
        body: "You retain all rights to the content you submit. You grant us a worldwide, non-exclusive license to host, process and display your content solely for the purpose of operating the Service.",
      },
      {
        h2: "5. Acceptable use",
        body: "Do not use the Service for unlawful, harmful, harassing or deceptive purposes · Do not attempt to reverse-engineer the Service or circumvent rate limits · Do not use the Service to build a competing product · Do not submit personal data of others without proper legal basis.",
      },
      {
        h2: "6. Fees and billing",
        body: "Plans are shown on the pricing page. We notify account owners before material billing changes.",
      },
      {
        h2: "7. Termination",
        body: "You may end your subscription at any time by emailing us. We may suspend or terminate accounts that violate these Terms or pose a security risk.",
      },
      {
        h2: "8. Warranties",
        body: 'The Service is provided "as is" without warranties of any kind. Like any software the Service may contain bugs, and AI-generated answers may contain factual errors or omissions — you are responsible for reviewing them before acting on them.',
      },
      {
        h2: "9. Limitation of liability",
        body: "To the maximum extent permitted by mandatory law, our aggregate liability arising out of or related to the Service — whether in contract, tort or otherwise — is limited to the fees actually paid by you to us for the Service in the twelve (12) months preceding the event giving rise to the claim. We exclude any liability for indirect, incidental, special, consequential or punitive damages, and for lost profits, lost revenue, lost data or loss of business opportunities. Nothing in these Terms limits liability that cannot be excluded under mandatory Swiss law, in particular liability for intentional acts or gross negligence (Art. 100 CO) or liability for personal injury.",
      },
      {
        h2: "10. Business customers only",
        body: "The Service is offered exclusively to businesses, self-employed persons, legal entities and public bodies acting in the exercise of their commercial or professional activity. It is not directed at consumers within the meaning of applicable consumer-protection law. By accepting these Terms you confirm that you are acting in a commercial or professional capacity.",
      },
      {
        h2: "11. Governing law",
        body: "These Terms are governed by the substantive laws of Switzerland, to the exclusion of its conflict-of-law rules and the United Nations Convention on Contracts for the International Sale of Goods (CISG). Exclusive jurisdiction lies with the competent courts of the Canton of Zürich, Switzerland.",
      },
      {
        h2: "12. Contact",
        body: 'Questions? Email <a href="mailto:hello@realitytwin.io">hello@realitytwin.io</a>.',
      },
    ],
  },
  dpa: {
    sectionsPre: [
      {
        h2: "1. Purpose",
        body: 'This Data Processing Addendum ("DPA") forms part of the Reality Twin <a href="/terms">Terms of Service</a> between Ruznic Marketing, Leimgrubstrasse 5, 8340 Hinwil, Switzerland ("Processor") and the customer ("Controller"). It governs the processing of personal data by the Processor on behalf of the Controller.',
      },
      {
        h2: "2. Roles",
        body: "The Controller determines the purposes and means of processing personal data submitted to the Service. The Processor processes that data only on documented instructions from the Controller.",
      },
      {
        h2: "3. Sub-processors",
        body: 'The current sub-processors used to deliver the Service are listed below. The full, always-current list — including regions and purposes — is maintained on the <a href="/subprocessors">sub-processors page</a>.',
      },
    ],
    spHeaders: { name: "Sub-processor", purpose: "Purpose", region: "Region" },
    subProcessors: [
      { name: "Cloudflare", purpose: "Edge runtime, CDN & DDoS protection", region: "Global edge" },
      {
        name: "Supabase",
        purpose: "Application database & authentication",
        region: "EU (Ireland)",
      },
      {
        name: "OpenAI / Anthropic",
        purpose: "Foundation-model inference for twin responses",
        region: "EU / US (opt-in)",
      },
      { name: "Resend", purpose: "Transactional email", region: "EU" },
    ],
    sectionsPost: [
      {
        h2: "4. International transfers",
        body: "Cross-border transfers (e.g. to US sub-processors used for model inference) rely on the European Commission's Standard Contractual Clauses and the Swiss FADP addendum, with supplementary measures including encryption in transit (TLS 1.3) and at rest (AES-256).",
      },
      {
        h2: "5. Security",
        body: 'See our <a href="/security">Security page</a> for the current state of our controls. SOC 2 and ISO 27001 certifications are on the roadmap, not yet in place.',
      },
      {
        h2: "6. Data subject rights",
        body: "The Processor assists the Controller in responding to data subject requests within statutory timelines (GDPR / Swiss FADP). Export and deletion are available on request.",
      },
      {
        h2: "7. Notification of changes",
        body: "We will provide at least 30 days' notice before adding or replacing a sub-processor. Controllers may object in writing during that period.",
      },
      {
        h2: "8. Signature",
        body: 'To execute the DPA, email <a href="mailto:hello@realitytwin.io">hello@realitytwin.io</a> with your entity details. We will return a counter-signed copy within two business days.',
      },
    ],
  },
  faq: {
    eyebrow: "Frequently asked",
    titlePre: "Everything about ",
    titleEm: "AI Twins",
    titlePost: ", in plain English.",
    sub: "What a Reality Twin actually does, how it compares to chatbots, what it costs, and how we handle your data.",
    stillTitle: "Still have a question?",
    stillPre: "The ",
    stillSupportLink: "Support Center",
    stillMid: " covers troubleshooting and how-tos, or write to ",
    stillPost: " — a human replies, usually within a business day.",
    groups: [
      {
        title: "AI Twins — the basics",
        items: [
          {
            q: "What is an AI Twin?",
            a: "An AI Twin is a conversational digital version of your company. It's trained on your own website, documents and product truth, and can answer visitors, qualify leads and route serious opportunities to your team — 24/7, in your voice, with citations back to the source.",
          },
          {
            q: "How is an AI Twin different from a chatbot?",
            a: "A traditional chatbot follows scripted flows or generic LLM answers. A Reality Twin is grounded in your knowledge graph — every reply is cited, memory is persistent per visitor, and the same twin can meet other twins in the network to broker introductions. See our comparisons: /vs-chatbase and /vs-botpress.",
          },
          {
            q: "How is an AI Twin different from a digital twin?",
            a: "Industrial digital twins model physical assets (a turbine, a factory). An AI Twin models a company's knowledge, offer and voice so it can hold real conversations with customers, partners and investors.",
          },
          {
            q: "How do I create an AI Twin?",
            a: "Sign up, paste your website URL, and Reality Twin crawls it, builds a citable knowledge graph and spins up your first twin — usually in about 60 seconds. You can then upload extra docs, tune the personality and embed the widget.",
          },
          {
            q: "Do I need to code to launch a twin?",
            a: "No. The setup and the embeddable widget are no-code. Developers can also drive everything via the REST API and (soon) the TypeScript SDK.",
          },
        ],
      },
      {
        title: "For business — sales, support, marketing",
        items: [
          {
            q: "What's the best AI chatbot for a small business?",
            a: "For small teams the trade-off is honest onboarding vs. deep configuration. Reality Twin is designed for founders and small teams: it self-installs from your website, captures and scores leads out of the box, and doesn't require an engineer to maintain. Free plan lets you validate before paying.",
          },
          {
            q: "Can an AI Twin qualify leads for my sales team?",
            a: "Yes. Every conversation is scored on intent and fit. Hot leads land in your inbox already enriched with company info, use case and next step, and can be pushed into HubSpot or Salesforce on Pro and above.",
          },
          {
            q: "Can the twin book meetings or appointments?",
            a: "Yes — on Starter and above you can connect a calendar and let the twin propose and confirm slots inside the conversation.",
          },
          {
            q: "Which channels can I deploy an AI Twin on?",
            a: "Today: your website (embeddable widget or full page), your marketplace profile, and the REST API. Slack, WhatsApp and email are on the roadmap.",
          },
          {
            q: "Does it work in languages other than English?",
            a: "Yes. Reality Twin is multilingual — the platform UI ships in 7 languages (EN, DE, ES, FR, IT, RU, ZH) and twins answer in whatever language the visitor writes in.",
          },
        ],
      },
      {
        title: "Knowledge, accuracy & hallucinations",
        items: [
          {
            q: "How do you prevent the twin from making things up?",
            a: "Every answer is grounded in your knowledge graph and cited back to the source document or page. If the twin can't find a citation, it says so and offers to route the question to a human — hallucinations are treated as bugs, not features.",
          },
          {
            q: "What knowledge sources can I connect?",
            a: "Your website (crawled automatically), uploaded documents (PDF, DOCX, MD, TXT, CSV and more) and text you paste in. Free plan covers your website; Starter adds documents; Pro is unlimited.",
          },
          {
            q: "How often does the twin re-crawl my website?",
            a: "Weekly by default; you can trigger a manual recrawl anytime, or use the API/webhook to push updates the moment your CMS publishes.",
          },
          {
            q: "Can I control the twin's personality and tone?",
            a: "Yes. You define voice (formal → playful), verbosity, refusal behaviour and topic boundaries. Changes go live immediately.",
          },
        ],
      },
      {
        title: "Pricing & plans",
        items: [
          {
            q: "Is there a free plan?",
            a: "Yes. Free includes 50 conversations/month, 1 AI Twin, a public marketplace listing and community support. No credit card required — see /pricing.",
          },
          {
            q: "How much does an AI Twin cost?",
            a: "Starter is CHF 39/mo (1,000 conversations, up to 3 Twins, lead capture), Pro is CHF 149/mo (5,000 conversations, unlimited Twins, Twin-to-Twin protocol) and Scale is CHF 399/mo (20,000 conversations). Conversations are a shared pool across all your twins and you can buy extra any time. See /pricing.",
          },
          {
            q: "What counts as a conversation?",
            a: "A conversation is a single visitor session with the twin, regardless of message count. Sessions expire after 30 minutes of inactivity.",
          },
          {
            q: "Can I upgrade, downgrade or cancel anytime?",
            a: "Yes — plan changes take effect immediately and are prorated. Cancel anytime from the billing screen; your data stays available for export for 30 days.",
          },
        ],
      },
      {
        title: "Privacy, data & hosting",
        items: [
          {
            q: "Where is my data stored?",
            a: "Application data lives in the European Union (Ireland). Reality Twin is a Swiss company under Swiss law — the company is Swiss, the storage is EU. Full details on /security and /dpa.",
          },
          {
            q: "Do you train shared models on my content?",
            a: "No. Your knowledge stays isolated to your workspace at the database row level with Row-Level Security. We never train shared foundation models on your content.",
          },
          {
            q: "Is Reality Twin GDPR-compliant?",
            a: "Yes — GDPR and Swiss FADP aligned. A signed DPA is available on request via hello@realitytwin.io.",
          },
          {
            q: "Who can access the twin's admin?",
            a: "Only accounts you invite to your workspace. All operator access is protected by MFA. Production access on our side is restricted to the founder and audit-logged.",
          },
        ],
      },
      {
        title: "Twin-to-Twin & the network",
        items: [
          {
            q: "What is the Twin-to-Twin protocol?",
            a: "When two twins in the network align on intent, capability and fit, Reality Twin proposes a meeting to both sides — no cold outreach. The protocol handles the discovery, the intent signals and the consent handshake.",
          },
          {
            q: "Is my company automatically listed in the marketplace?",
            a: "Only if you opt in. You control the public profile, what the twin will disclose to other twins, and which industries can discover you.",
          },
        ],
      },
      {
        title: "Cost, setup & getting started",
        items: [
          {
            q: "How much does an AI chatbot cost?",
            a: "It ranges from free to thousands per month depending on volume and vendor. Reality Twin starts free (50 conversations/month), then CHF 39 (Starter, 1,000), CHF 149 (Pro, 5,000) and CHF 399 (Scale, 20,000). Conversations are a shared pool across all your twins and you can buy more any time — see /pricing.",
          },
          {
            q: "How do I add an AI chatbot to my website?",
            a: "With Reality Twin you paste one script tag into your site and the twin appears as a chat widget — no code beyond that. You can also embed a full-page version or drive it via the REST API and MCP server.",
          },
          {
            q: "How long does it take to set up?",
            a: "About 60 seconds for a first working twin from your website. Uploading extra documents, tuning the voice and connecting your CRM is measured in days, not months.",
          },
          {
            q: "Can I build an AI chatbot without coding?",
            a: "Yes. Setup, knowledge, personality and the embed widget are all no-code. Developers can additionally use the REST API and MCP server if they want deeper control.",
          },
          {
            q: "Is an AI chatbot worth it for a small business?",
            a: "For most small businesses, yes: it answers repetitive questions 24/7, captures leads you'd otherwise miss overnight, and needs no extra headcount. The free tier lets you validate the value before paying anything.",
          },
        ],
      },
      {
        title: "Comparisons, languages & compliance",
        items: [
          {
            q: "What's the difference between an AI Twin and a normal AI chatbot?",
            a: "A chatbot follows scripts or gives generic answers. An AI Twin is grounded in your own knowledge with citations, remembers visitors, qualifies and scores leads into your CRM, and can even be discovered by other companies' twins in a network.",
          },
          {
            q: "Is Reality Twin a good Chatbase or Botpress alternative?",
            a: "For B2B teams that care about pipeline rather than deflection, yes. It adds grounding with citations, real lead qualification and CRM write-back, and Twin-to-Twin discovery. See /vs-chatbase and /vs-botpress for detailed comparisons.",
          },
          {
            q: "Does the AI chatbot support multiple languages?",
            a: "Yes. The platform interface ships in 7 languages, and twins answer in whatever language the visitor writes in — so one twin serves a global audience without extra setup.",
          },
          {
            q: "Is an AI chatbot GDPR compliant?",
            a: "Reality Twin is aligned with the GDPR and the Swiss FADP. Application data lives in the European Union (Ireland), your knowledge is isolated per workspace with row-level security, and a signed DPA is available on request.",
          },
          {
            q: "Will AI replace my support or sales team?",
            a: "No — it removes the repetitive first layer so your team spends time on the conversations that need judgment. The strongest setups pair an AI Twin for instant 24/7 answers with humans for the complex, high-value cases.",
          },
        ],
      },
    ],
  },
  connect: {
    eyebrow: "Agent connection",
    title: "Connect Reality Twin to your AI assistant",
    sub: "Give ChatGPT or Claude access to Reality Twin in under a minute. Copy the server URL below, then follow the steps for your assistant.",
    urlLabel: "MCP server URL",
    copy: "Copy",
    copied: "Copied",
    note: "Once connected, your assistant can search the marketplace, ask public twins questions and submit leads on your behalf.",
    openLink: "Open settings",
    chatgptSteps: [
      "Open ChatGPT → Settings → Connectors → Advanced and enable Developer mode (read the risk notice shown there).",
      "In the chat composer, open the + menu and turn on Developer mode.",
      "Click Add sources, then Connect more.",
      "Name the connector (e.g. “Reality Twin”) and paste the MCP URL above.",
      "Start a chat and ask ChatGPT to use Reality Twin.",
    ],
    claudeSteps: [
      "Open Claude → Settings → Custom connectors.",
      "Name the connector (e.g. “Reality Twin”) and paste the MCP URL above.",
      "Enable the connector from the chat composer, then ask Claude to use Reality Twin.",
    ],
  },
  auth: {
    forgotTitle: "Reset password",
    forgotSub: "We'll email you a secure link to set a new password.",
    emailLabel: "Email",
    send: "Send reset link",
    sending: "Sending…",
    sentPre: "Check your inbox at ",
    sentPost: " for a reset link.",
    back: "Back to sign in",
    resetTitle: "Set new password",
    waiting: "Waiting for recovery link… If nothing happens, request a new link.",
    newPassword: "New password",
    confirmLabel: "Confirm",
    update: "Update password",
    updating: "Updating…",
    tooShort: "Min 8 characters",
    mismatch: "Passwords don't match",
    updated: "Password updated",
    joinChecking: "Checking your invitation…",
    joinJoining: "Joining the workspace…",
    joinInvited: "You've been invited",
    joinInvitedSub:
      "Sign in or create an account, then open this invite link again to join your team's workspace.",
    joinSignIn: "Sign in / Sign up",
    joinWelcome: "Welcome to {{name}}",
    joinRedirect: "Taking you to the dashboard…",
    joinError: "Invitation problem",
    joinBack: "Back to Reality Twin",
  },
  directory: {
    market: {
      title: "Twin marketplace",
      sub: "Discover AI Twins publishing to the network. Chat with companies. Find partners, customers, and investors.",
      dealsBanner: "Live deals on the Exchange — products, suppliers, capital",
      searchPh: "Search companies…",
      allIndustries: "All industries",
      allCountries: "All countries",
      searchBtn: "Search",
      empty: "No public twins yet. Be the first.",
      noDesc: "No description yet.",
      chat: "Chat with twin",
    },
    deals: {
      title: "Live deals",
      sub: "Concrete offers and needs from companies on the network — products seeking retailers, buyers sourcing suppliers, startups raising capital, investors deploying it.",
      all: "All",
      industryPh: "Industry",
      countryPh: "Country",
      searchPh: "Search deals…",
      emptyPre: "No live deals in this category yet. ",
      emptyCta: "Post the first one →",
      view: "View deal",
      ctaTitle: "Your deal belongs here",
      ctaSub:
        "Post what you sell, source, raise or invest — the network matches you with the right counterpart and notifies them automatically.",
      ctaBtn: "Post a listing",
    },
    services: {
      title: "Find a service pro",
      sub: "Request a free, non-binding quote. Chat with the company's AI twin first, book the appointment and pay securely online — funds only flow when you confirm.",
      badgeSecure: "Secure online payment",
      badgeAsk: "Ask the AI twin anything first",
      badgeFree: "Free & non-binding quotes",
      all: "All",
      countryPh: "Country",
      searchPh: "Search providers…",
      sentPre: "Request sent to ",
      sentPost:
        " — you'll receive a quote by email with a secure payment link. Non-binding until you pay.",
      empty: "No providers in this category yet. ",
      emptyCta: "Offer your services →",
      requestQuote: "Request quote",
      askTwin: "Ask twin",
      modalTitle: "Request a quote from {{name}}",
      modalSub:
        "Free and non-binding. You'll receive the price by email and can pay securely online.",
      phName: "Your name",
      phEmail: "Email",
      phDate: "Preferred date (e.g. next week)",
      phBudget: "Budget (optional)",
      phMessage: "What do you need? (rooms, dates, details…)",
      send: "Send request",
      sending: "Sending…",
      sendError: "Could not send request",
    },
    types: {
      product_offer: "Sell a product",
      product_demand: "Source products",
      invest_ask: "Raise capital",
      invest_offer: "Invest capital",
      service_offer: "Offer a service",
      service_demand: "Find a supplier",
      partnership: "Strategic partnership",
      license_offer: "License out IP",
      license_demand: "Find technology / IP",
      business_sale: "Sell a business (M&A)",
      business_buy: "Acquire a business",
    },
    categories: {
      Painter: "Painter",
      Electrician: "Electrician",
      Plumber: "Plumber",
      Carpenter: "Carpenter",
      Gardener: "Gardener",
      Cleaning: "Cleaning",
      Moving: "Moving",
      Roofing: "Roofing",
      "Heating & Climate": "Heating & Climate",
      "IT & Software": "IT & Software",
      "Web & Design": "Web & Design",
      Marketing: "Marketing",
      Photography: "Photography",
      Legal: "Legal",
      Accounting: "Accounting",
      Consulting: "Consulting",
    },
  },
  profile: {
    metricResponseRate: "Response rate",
    metricResponseRateSub: "Inbound requests acted on",
    metricResponseTime: "Response time",
    metricResponseTimeSub: "Typical first reply",
    metricCompletion: "Completion rate",
    metricCompletionSub: "Engaged work finished",
    notFound: "Twin not found or private.",
    loading: "Loading…",
    leadSuccess: "{{name}} will get back to you.",
    leadError: "Could not send — please try again.",
    back: "Back to marketplace",
    live: "Twin live",
    verified: "Verified profile",
    visitWebsite: "Visit website ↗",
    briefEyebrow: "Public intelligence brief",
    companyFallback: "Company",
    networkFallback: "Network",
    briefTitle: "What {{name}} brings into the twin-to-twin network",
    briefFallback:
      "{{name}} has published a live AI Twin profile for discovery, qualification, and direct commercial conversations.",
    industry: "Industry",
    hq: "Headquarters",
    size: "Company size",
    unspecified: "Unspecified",
    global: "Global",
    notDisclosed: "Not disclosed",
    marketSignals: "Market signals",
    twinOutcomes: "Twin outcomes",
    signalArchitecture: "Signal architecture",
    directLine: "Direct line",
    reachTitle1: "Reach the team",
    reachTitle2: "behind {{name}}.",
    leadSub:
      "Leave your details and a real person from {{name}} will follow up — usually within one business day.",
    phFullName: "Full name",
    phWorkEmail: "Work email",
    phInterest: "What are you interested in? (optional)",
    sending: "Sending…",
    requestIntro: "Request introduction →",
    messageSent: "Message sent",
    willReachOut: "{{name}} will reach out to you directly.",
    twinOS: "Twin operating system",
    osTitle: "Live company intelligence, not a static directory card.",
    metricReadiness: "Twin readiness",
    metricPages: "Pages indexed",
    metricDocs: "Documents",
    metricKb: "Knowledge base",
    websiteIntel: "Website intelligence",
    crawlPending: "Crawl pending",
    knowledgeFiles: "Knowledge files",
    noFiles: "No files indexed",
    indexedSignals: "Indexed signals",
    profileKnowledge: "Profile knowledge",
    readiness: {
      networkGrade: "Network-grade",
      commercial: "Commercially useful",
      training: "Training in progress",
      foundation: "Foundation profile",
    },
    discoveryLayer: "Discovery layer",
    publicProfile: "Public twin profile",
    commercialIntent: "Commercial intent",
    trustState: "Trust state",
    chatTitle: "{{name}} intelligence chat",
    liveEndpoint: "Live twin endpoint",
    inquiryDeck: "Inquiry deck",
    startFrom: "Start from strategy, fit, partnerships or buyer intent.",
    askAnything: "Ask {{name}} anything…",
    send: "Send",
    starters: [
      "Where does {{name}} create the most value?",
      "Which companies should partner with {{name}}?",
      "What should a buyer know before contacting {{name}}?",
    ],
    defaultOutcomes: ["Lead qualification", "Partner discovery", "Direct company Q&A"],
    defaultCapabilities: ["Company discovery", "Commercial conversations", "Human handoff"],
  },
  dealDetail: {
    notLive: "This deal is no longer live. ",
    browse: "Browse live deals →",
    back: "All live deals",
    by: "by",
    viewAttachment: "View attachment",
    askTwinTitle: "Ask {{name}}'s twin about this deal",
    askTwinSub: "Get instant answers about the company, the offer and next steps — 24/7.",
    chatNow: "Chat now",
    forYouTitle: "Is this deal meant for you?",
    forYouSub:
      "Post your matching listing — the network connects you and notifies {{name}} automatically.",
    respondCta: "Respond with a listing",
  },
  pay: {
    browseProviders: "Browse providers →",
    confirming: "Confirming your payment…",
    loading: "Loading your quote…",
    service: "Service",
    yourQuote: "Your quote",
    preferredDate: "Preferred date: ",
    providerLabel: "Provider",
    vat: "VAT: ",
    paymentReceived: "Payment received",
    notified:
      "{{name}} has been notified and will contact you to schedule the appointment. A receipt was sent by email.",
    howWas: "How was {{name}}?",
    reviewPh: "A sentence about the experience (optional)",
    submitReview: "Submit review",
    submitting: "Submitting…",
    reviewThanks: "Thanks — your review is live in the directory.",
    reviewError: "Could not submit review",
    reviewSubmitted: "Review submitted — thank you.",
    payBtn: "Pay securely & book",
    redirecting: "Redirecting to secure checkout…",
    stripeNote:
      "Processed by Stripe · booking confirmed instantly · Reality Twin platform fee included",
    quoteNotFound: "Quote not found",
    confirmError: "Payment could not be confirmed yet",
    payStartError: "Could not start payment",
  },
  vs: {
    eyebrow: "Comparison",
    shortAnswer: "The short answer",
    sideBySide: "Side-by-side",
    capability: "Capability",
    whenThem: "When {{name}} is right",
    whenUs: "When Reality Twin is right",
    migrating: "Migrating to Reality Twin",
    ctaTitle: "See what your Twin would say — in minutes.",
    ctaBody:
      "The free tier includes conversations, one Twin and a public marketplace listing. No credit card.",
    startFree: "Start free",
    seePricing: "See pricing",
    howItWorks: "How the platform works",
    faqEyebrow: "FAQ",
    faqTitle: "Questions people ask",
    disclaimer:
      "Comparison based on publicly documented features. {{name}} is a trademark of its respective owner and is not affiliated with Reality Twin.",
    allComparisons: "All comparisons",
    keepReading: "Keep reading",
    compareSub: "See how Reality Twin stacks up against every major alternative.",
  },
  compare: {
    eyebrow: "Comparisons",
    title: "Reality Twin vs. the alternatives",
    subtitle: "Honest, side-by-side comparisons so you can pick the right tool for B2B.",
  },
  useCases: {
    eyebrow: "Use cases",
    titleA: "One AI Twin, ",
    titleEm: "many jobs.",
    sub: "A Reality Twin isn't a single-purpose bot. The same grounded model answers customers, qualifies leads and gets you discovered — across every team and industry.",
    getStarted: "Get started free",
    seePricing: "See pricing",
    byTeamEyebrow: "By team",
    byTeamTitleA: "Where a Twin ",
    byTeamTitleEm: "earns its keep.",
    byIndustryEyebrow: "By industry",
    byIndustryTitleA: "Built for ",
    byIndustryTitleEm: "how you sell.",
    ctaTitle: "Find your use case in a live conversation.",
    ctaSub:
      "Spin up a Twin from your website in about 60 seconds and see it work on your own content — free to start.",
    readBlog: "Read the blog",
    roles: [
      {
        title: "Sales & lead generation",
        desc: "Qualify every inbound visitor against your ICP, capture the lead in-conversation with full context, and route hot ones to a rep in seconds. Speed-to-lead, on autopilot.",
        linkLabel: "How to convert visitors with AI",
      },
      {
        title: "Customer support",
        desc: "Resolve the repetitive 60–80% of tickets instantly, grounded in your real docs, and escalate the rest with a clean, written handoff. Automation customers don't resent.",
        linkLabel: "AI support automation guide",
      },
      {
        title: "Marketing & content",
        desc: "Turn read-only pages into conversations. Visitors self-discover what's relevant, and every chat tells you which questions your content should answer next.",
        linkLabel: "See the platform",
      },
      {
        title: "Agencies & resellers",
        desc: "Run a Twin on your own site, then productize setup + management as a high-margin recurring service across every client — many twins from one account.",
        linkLabel: "The agency playbook",
      },
    ],
    industries: [
      {
        title: "SaaS & software",
        desc: "Answer feature, pricing and integration questions with cited docs; qualify trials and book demos while your team sleeps.",
      },
      {
        title: "Professional services",
        desc: "Scope, availability and pricing questions handled instantly; serious enquiries booked straight into a calendar.",
      },
      {
        title: "E-commerce & retail",
        desc: "Product guidance, sizing, shipping and returns answered in the moment — fewer support tickets, more completed carts.",
      },
      {
        title: "B2B & manufacturing",
        desc: "Route real buyers to sales with context, and get discovered by other companies' twins in the network.",
      },
    ],
  },
  subprocessors: {
    intro1:
      'Reality Twin uses a small number of third-party service providers ("sub-processors") to operate the platform. This page lists them, what they do and where they run. It complements our <a href="/dpa">Data Processing Addendum</a> and <a href="/privacy">Privacy notice</a>.',
    intro2:
      "Cross-border transfers (in particular for AI model inference) rely on the European Commission's Standard Contractual Clauses and the Swiss FADP addendum, with technical measures including TLS 1.3 in transit and AES-256 at rest.",
    thName: "Sub-processor",
    thPurpose: "Purpose",
    thRegion: "Region",
    rows: [
      {
        purpose:
          "Application hosting, edge runtime and Lovable AI Gateway used to route model inference requests.",
        region: "EU (application) · Global (AI Gateway may forward to non-EU providers, incl. US)",
      },
      {
        purpose: "Primary application database, authentication and storage.",
        region: "EU (Dublin, Ireland)",
      },
      {
        purpose: "Subscription billing and payment processing.",
        region: "EU / US (SCCs)",
      },
      {
        purpose: "CDN, DNS, DDoS protection and edge caching.",
        region: "Global edge",
      },
      {
        purpose: "Transactional email delivery (account, billing and product notifications).",
        region: "EU",
      },
    ],
    changesTitle: "Changes",
    changesBody:
      'We provide at least 30 days\' notice before adding or replacing a sub-processor. To be notified of changes, email <a href="mailto:hello@realitytwin.io">hello@realitytwin.io</a>.',
  },
  impressum: {
    project: "Project",
    legalForm: "Legal form",
    soleProprietorship: "Sole proprietorship (Einzelunternehmen), Switzerland",
    registerNote:
      "As a Swiss sole proprietorship, entry in the commercial register and VAT registration are only mandatory above CHF 100'000 in annual turnover.",
    eyebrow: "Legal",
    title: "Imprint",
    intro:
      "Provider identification for realitytwin.io. Reality Twin is built and operated in Switzerland.",
    providerTitle: "Provider",
    company: "Operated by",
    responsible: "Responsible",
    address: "Address",
    contact: "Contact",
    website: "Website",
    swissTitle: "Built and operated in Switzerland",
    swissBody:
      "Reality Twin is a Swiss product: developed in Hinwil, Zurich, operated by a Swiss company and governed by Swiss law, with Hinwil as the place of jurisdiction. Application data is hosted in the European Union (Ireland) and covered by the GDPR and the Swiss FADP, with a Data Processing Addendum available to every customer.",
    liabilityTitle: "Liability for content",
    liabilityBody:
      "We prepare the content of this site with care, but assume no liability for its accuracy, completeness or timeliness. Answers generated by AI Twins are informational and non-binding unless a company has explicitly authorised binding statements.",
    linksTitle: "Liability for links",
    linksBody:
      "Our site links to external websites over whose content we have no influence. The respective provider is always responsible for the content of linked pages.",
    copyrightTitle: "Copyright",
    copyrightBody:
      "The content and works on these pages are protected by copyright. Reproduction, editing or distribution beyond the limits of copyright law requires our written consent.",
    disputeTitle: "Dispute resolution",
    disputeBody:
      "We are neither obliged nor willing to participate in dispute resolution proceedings before a consumer arbitration board. For any question or complaint, write to us directly — we answer every message.",
  },
  industries: {
    h1: "Your company, reachable by AI —",
    gainsTitle: "What a Twin changes",
    queriesTitle: "What your buyers ask an AI assistant",
    queriesNote: "If your company can't be read by a model, the answer names someone else.",
    faqTitle: "Questions we get asked",
    ctaCheck: "Check your AI-readability — free",
    ctaStart: "Build your Twin",
    ctaTitle: "See how AI reads your company today",
    ctaBody:
      "Free, no account. Paste your website and get the findings — then ask your own Twin a question.",
    more: "Other industries",
  },
  industriesHub: {
    eyebrow: "By industry",
    title: "Every business is being read by AI.",
    sub: "Buyers now ask an assistant before they ask you. What that assistant says about your company depends on what it can read. Pick your line of business to see what changes.",
    missingTitle: "Your industry isn’t listed?",
    missingBody:
      "The twin learns from your own website and documents, so it doesn’t need a template for your sector. Run the free check and see how AI reads your company today.",
    cta: "Check your AI-readability — free",
    talk: "Talk to us",
  },
};

export default routes;
export type RouteContent = typeof routes;
